import _implicitStylesheets from "./orgDetailsPanel.css";

import _implicitScopedStylesheets from "./orgDetailsPanel.scoped.css?scoped=true";

import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {t: api_text, h: api_element, d: api_dynamic_text} = $api;
  return [$cmp.isUserLoggedIn ? api_element("div", {
    key: 0
  }, [api_element("h3", {
    classMap: {
      "userorg-info_align": true
    },
    key: 1
  }, [api_element("span", {
    classMap: {
      "userorg-title_align": true
    },
    attrs: {
      "data-my-id": "orgUserTitle"
    },
    key: 2
  }, [api_text("User")]), api_text(" " + api_dynamic_text($cmp.userName))]), api_element("h3", {
    classMap: {
      "userorg-info_align": true
    },
    key: 3
  }, [api_element("span", {
    classMap: {
      "userorg-title_align": true
    },
    attrs: {
      "data-my-id": "orgUserInfo"
    },
    key: 4
  }, [api_text("Org")]), api_text("  " + api_dynamic_text($cmp.organizationId))]), api_element("div", {
    classMap: {
      "div-border_bottom": true
    },
    key: 5
  }, [])]) : null];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-orgDetailsPanel_orgDetailsPanel"
